import type { ReactNode } from 'react';

/**
 * A card for something planned but not built: a hatched top edge and a
 * "Coming soon" pill, so nobody mistakes the empty space for missing data.
 * Deliberately not `MockedOverlay`, which says "the data here is fake"; this
 * says "there is nothing here yet".
 */
export function ComingSoonCard({ title, children }: { title: string; children: ReactNode }) {
  return (
    <section
      className="nb-card"
      aria-label={`${title}, coming soon`}
      style={{
        flex: '0 0 auto',
        backgroundImage:
          'repeating-linear-gradient(45deg, var(--nb-warn-soft) 0 6px, transparent 6px 12px)',
        backgroundSize: '100% 3px',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top',
      }}
    >
      <div className="nb-card-hd" style={{ marginBottom: 8 }}>
        <h3>{title}</h3>
        <span
          className="nb-pill"
          style={{
            height: 18,
            fontSize: 9,
            padding: '0 7px',
            fontWeight: 700,
            letterSpacing: '.05em',
            textTransform: 'uppercase',
            background: 'var(--nb-warn-soft)',
            color: 'var(--nb-ink)',
            borderColor: 'transparent',
          }}
        >
          Coming soon
        </span>
      </div>
      <div style={{ fontSize: 11.5, color: 'var(--nb-muted)', lineHeight: 1.5 }}>{children}</div>
    </section>
  );
}
